<script setup>
import { useAuthStore } from "@stores/auth";
import { useMenuStore } from '@/stores/menu';



const authStore = useAuthStore();
const route = useRoute();
const menuStore = useMenuStore();

const showMenuLogger = computed(() => {
  return /^\/user\/account$/.test(route.path) && authStore.isLoggedIn;
});

const showMenuLogger2 = computed(() => {
  return /^\/user\/account\/.+$/.test(route.path);
});
const props = defineProps({
    teste: {
        type: Boolean,
        required: false,
        default: false,
    },
});

</script>
<template>
    
    <NuxtLink to="/user/account" @click="menuStore.userClose()" :class="!showMenuLogger && showMenuLogger2 ? 'flex md:hidden' : 'hidden md:hidden'" class="flex items-center gap-2 mb-4 font-bold">
        <icon name="material-symbols:chevron-left" size="20"/>
        <p>Voltar</p>
    </NuxtLink>


    <transition name="fade">
        <div 
            class="flex flex-col gap-2 sm:gap-3 w-full md:min-w-72 md:max-w-72  md:mr-4 md:flex" 
            :class="[
                showMenuLogger ? '' : 'hidden md:flex', 
                
                menuStore.menuUser ? 'hidden md:flex' : 'flex md:flex'
               
            ]">
            <UserPaginationMenu
                name="Meu dados"
                class="transition-all"
                icon="fa6-solid:user"
                to-link="/user/account"
                @click="menuStore.userOpen()"
            />
            <UserPaginationMenu
                name="Documentos"
                class="transition-all"
                icon="fa6-solid:address-card"
                to-link="/user/account/document"
            />
            <UserPaginationMenu
                name="Alterar senha"
                class="transition-all"
                icon="fluent:key-reset-24-filled"
                to-link="/user/account/password"
            />
        </div>
    </transition>
</template>
    